import { DEFAULT_IMAGES_360_PATH, IMAGE_FORMATS, } from "../constants";
var getDefaultImagePath = function (_a) {
    var staticSourceUrl = _a.staticSourceUrl, size = _a.size, name = _a.name, format = _a.format;
    return "".concat(staticSourceUrl, "/").concat(DEFAULT_IMAGES_360_PATH, "/").concat(size, "/").concat(name, ".").concat(format);
};
export var defaultImages = {
    demo360: function (staticSourceUrl, size, isWebp) {
        return getDefaultImagePath({
            staticSourceUrl: staticSourceUrl,
            size: size,
            name: "360_demo",
            format: isWebp ? IMAGE_FORMATS.webp : IMAGE_FORMATS.jpg,
        });
    },
    teaser360: function (staticSourceUrl, size, isWebp) {
        return getDefaultImagePath({
            staticSourceUrl: staticSourceUrl,
            size: size,
            name: "360_demo",
            format: isWebp ? IMAGE_FORMATS.webp : IMAGE_FORMATS.jpg,
        });
    },
};
